module.exports = __webpack_public_path__ + "img/step24_a_printer_basic_connect_power_lan_cable.81f0f58d.png";